import { render, staticRenderFns } from "./ShiftEditorAdditionalFields.vue?vue&type=template&id=212e4e82&scoped=true&lang=pug&"
import script from "./ShiftEditorAdditionalFields.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorAdditionalFields.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditorAdditionalFields.vue?vue&type=style&index=0&id=212e4e82&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212e4e82",
  null
  
)

export default component.exports